export default "__VITE_ASSET__CZn6hbwm__"